import { render, staticRenderFns } from "./ModalEditRole.vue?vue&type=template&id=67d45ddb&scoped=true&"
import script from "./ModalEditRole.vue?vue&type=script&lang=js&"
export * from "./ModalEditRole.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditRole.vue?vue&type=style&index=0&id=67d45ddb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d45ddb",
  null
  
)

export default component.exports